import React from "react";

/** State B: live progress while the server processes the rows. */
const ImportProgress = ({ batch, isReconnecting }) => {
  const stats = batch?.stats || {};
  const total = stats.total || 0;
  const processed = stats.processed || 0;
  const percent = total
    ? Math.min(100, Math.round((processed / total) * 100))
    : 0;

  return (
    <div className="import-card">
      <div className="d-flex align-items-center gap-2 mb-1">
        <span
          className="spinner-border spinner-border-sm text-primary"
          aria-hidden="true"
        ></span>
        <h5 className="fw-bold text-navy m-0">Importing…</h5>
      </div>
      <p className="text-slate-500 fs-085 mb-4">
        <i className="bi bi-file-earmark-excel me-1"></i>
        {batch?.fileName || "Uploaded file"}
        {total ? <> · {total.toLocaleString()} rows</> : null}
      </p>

      <div className="d-flex justify-content-between fs-080 fw-semibold text-slate-700 mb-1">
        <span>
          {processed.toLocaleString()} of {total.toLocaleString()} rows
          processed
        </span>
        <span>{percent}%</span>
      </div>
      <div
        className="progress import-progress mb-4"
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Import progress"
      >
        {/* Width is runtime data, so it stays inline */}
        <div
          className="progress-bar progress-bar-striped progress-bar-animated"
          style={{ width: `${percent}%` }}
        ></div>
      </div>

      <div className="import-counters mb-4" aria-live="polite">
        <div className="import-counter import-counter--success">
          <i className="bi bi-check-circle-fill"></i>
          <span className="value">{(stats.success || 0).toLocaleString()}</span>
          <span className="label">Success</span>
        </div>
        <div className="import-counter import-counter--partial">
          <i className="bi bi-exclamation-triangle-fill"></i>
          <span className="value">{(stats.partial || 0).toLocaleString()}</span>
          <span className="label">Partial</span>
        </div>
        <div className="import-counter import-counter--failed">
          <i className="bi bi-x-circle-fill"></i>
          <span className="value">{(stats.failed || 0).toLocaleString()}</span>
          <span className="label">Failed</span>
        </div>
      </div>

      {isReconnecting && (
        <div className="alert alert-secondary fs-080 py-2" role="status">
          <i className="bi bi-wifi-off me-2"></i>
          Connection problem, retrying… The import is still running on the
          server.
        </div>
      )}

      <div className="import-note fs-080">
        <i className="bi bi-info-circle me-2"></i>
        You can leave this page; the import continues on the server. Come back
        to this page (or the Import button) to see the results.
      </div>
    </div>
  );
};

export default ImportProgress;
